const StyledHeadingText = ({ text, TextColor: TextColor, size }) => {
    return (
        <p className={`${size || "text - xl"} font-bold ${TextColor}`}>{text}</p>
    );
};

export default StyledHeadingText;
